import { render, staticRenderFns } from "./BeforeCreate.vue?vue&type=template&id=f5722d56&"
import script from "./BeforeCreate.vue?vue&type=script&lang=js&"
export * from "./BeforeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports